/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * active_total object
 * @export
 * @interface GetFwLeaderboardsActiveTotalActiveTotal1
 */
export interface GetFwLeaderboardsActiveTotalActiveTotal1 {
    /**
     * Amount of victory points
     * @type {number}
     * @memberof GetFwLeaderboardsActiveTotalActiveTotal1
     */
    amount?: number;
    /**
     * faction_id integer
     * @type {number}
     * @memberof GetFwLeaderboardsActiveTotalActiveTotal1
     */
    factionId?: number;
}

/**
 * Check if a given object implements the GetFwLeaderboardsActiveTotalActiveTotal1 interface.
 */
export function instanceOfGetFwLeaderboardsActiveTotalActiveTotal1(value: object): value is GetFwLeaderboardsActiveTotalActiveTotal1 {
    return true;
}

export function GetFwLeaderboardsActiveTotalActiveTotal1FromJSON(json: any): GetFwLeaderboardsActiveTotalActiveTotal1 {
    return GetFwLeaderboardsActiveTotalActiveTotal1FromJSONTyped(json, false);
}

export function GetFwLeaderboardsActiveTotalActiveTotal1FromJSONTyped(json: any, ignoreDiscriminator: boolean): GetFwLeaderboardsActiveTotalActiveTotal1 {
    if (json == null) {
        return json;
    }
    return {
        
        'amount': json['amount'] == null ? undefined : json['amount'],
        'factionId': json['faction_id'] == null ? undefined : json['faction_id'],
    };
}

export function GetFwLeaderboardsActiveTotalActiveTotal1ToJSON(json: any): GetFwLeaderboardsActiveTotalActiveTotal1 {
    return GetFwLeaderboardsActiveTotalActiveTotal1ToJSONTyped(json, false);
}

export function GetFwLeaderboardsActiveTotalActiveTotal1ToJSONTyped(value?: GetFwLeaderboardsActiveTotalActiveTotal1 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'amount': value['amount'],
        'faction_id': value['factionId'],
    };
}

